import { useAction, useAtom, useCtx } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Array } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { reatomSetFavoritesOrder } from '@root/features/favorite-pairs'
import { reatomFavoritePairsTable } from '@root/features/favorite-pairs/atoms/reatom-favorite-pairs-table'
import { FavoriteUnavailable } from '@root/features/favorite-pairs/model/favorite-unavailable'

import { TopbarError } from '../common/topbar-error'
import { TopbarPairItemSkeleton } from '../common/topbar-pair-item-skeleton'

import { TopbarFavoritesList } from './topbar-favorites-list'

export const TopbarFavorites: React.FC = () => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const tableModelAtom = useMemo(() => reatomFavoritePairsTable(), [])
  const { setFavoritePairsOrderRequestState } = useMemo(
    () => reatomSetFavoritesOrder(),
    [],
  )
  const ctx = useCtx()
  const [network] = useAtom(selectedNetworkAtom)
  const [tableModel] = useAtom(tableModelAtom)
  const loadFavorites = useAction(tableModelAtom.load)
  const setFavoritePairsOrder = useAction(
    setFavoritePairsOrderRequestState.execute,
  )

  const handleReload = () => loadFavorites()

  return (
    <Root>
      {AsyncStateN.matchWaiting(tableModel, {
        Success: ({ data }) => {
          if (data.length === 0) {
            return <TopbarError onReload={handleReload} intent="empty" />
          }

          return (
            <TopbarFavoritesList
              favoritePairs={data}
              onReorder={(newFavoritesOrder) => {
                setFavoritePairsOrder({
                  favoritePairsOrder: newFavoritesOrder
                    .map((x) => {
                      return x instanceof FavoriteUnavailable
                        ? x.favoriteId
                        : ctx.get(x.favoriteMeta)?.favoriteId
                    })
                    .filter((x) => x !== undefined),
                  network,
                })
              }}
            />
          )
        },
        Error: () => <TopbarError onReload={handleReload} />,
        Waiting: () => (
          <List>
            {Array.range(0, 2).map((x) => (
              <SkeletonItem key={x}>
                <TopbarPairItemSkeleton />
              </SkeletonItem>
            ))}
          </List>
        ),
      })}
    </Root>
  )
}

const Root = styled.div``

const List = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
`

const SkeletonItem = styled.div`
  padding: 0 5px;
`
